export function CurrencySelector(context = document) {
    const els = context.querySelectorAll('.js-currency-selector')
    Array.from(els).forEach(ele => ele.addEventListener('change', submitForm));
}

function submitForm() {
    this.form.submit();
}
